import axios from 'axios'

import {handleRequest} from './base/handleRequest'
import {
	API_ACCOUNTS,
	API_APPRENTICE,
	API_APPRENTICES,
	API_PERSON,
	API_PERSONS,
	API_TRIAL_PERIOD_REPORT,
	API_TRIAL_PERIOD_REPORTS,
	API_WARM_UP_URL
} from '../../constants'
import {RequestMethod} from '../../model/enums/enums'
import {ApprenticeBody, Person} from '../../model/person.model'
import {State} from '../../model/state.model'
import {TrialPeriodReport} from '../../model/trialPeriodReport.model'


export const sendWarmup = () => {
	console.log('[Sending warmup] to cloud run...')
	axios.get(API_WARM_UP_URL)
		.then(() => console.log('[Sending warmup] finished. ...ready for requests'))
		.catch(() => console.error('[Sending warmup] failed. ...Backend not ready.')
		)
}

export const loadAllTrialPeriodReports = (): Promise<State<TrialPeriodReport[]>> => {
	return handleRequest<TrialPeriodReport[]>(API_TRIAL_PERIOD_REPORTS(), RequestMethod.GET)
}

export const getPersonById = (person_id: number): Promise<State<Person>> => {
	return handleRequest<Person>(API_PERSON(person_id), RequestMethod.GET)
}

/**
 * Add a person to the database
 * @param person
 */
export const addPersonToDb = (person: Person): Promise<State<Person>> => {
	return handleRequest<Person>(API_PERSONS(), RequestMethod.POST, person)
}

/**
 * Add an account to the database
 * @param account
 */
export const addAccountToDb = (account: any): Promise<State<any>> => {
	return handleRequest<any>(API_ACCOUNTS(), RequestMethod.POST, account)
}

export const addApprenticeToDb = (account: any): Promise<State<ApprenticeBody>> => {
	return handleRequest<ApprenticeBody>(API_APPRENTICES(), RequestMethod.POST, account)
}

/**
 * update an existing person in the database
 * @param id, the ID of the person
 * @param body, the body either an entire person-object or only a single value like "middle_name" as valid json object
 */
export const updatePersonInDb = (id: number, body: any): Promise<State<Person>> => {
	return handleRequest<Person>(API_PERSON(id), RequestMethod.PUT, body)
}

export const updateApprenticeInDb = (id: number, body: any): Promise<State<ApprenticeBody>> => {
	return handleRequest<ApprenticeBody>(API_APPRENTICE(id), RequestMethod.PUT, body)
}

/**
 * Update the Company on the data base with new provided values
 * @param id
 * @param body
 */

export const updateTrialPeriodReportInDb = (id: number, body: any): Promise<State<TrialPeriodReport>> => {
	return handleRequest<TrialPeriodReport>(API_TRIAL_PERIOD_REPORT(id), RequestMethod.PUT, body)
}
